import { KeyLabel } from "interfaces/models/documentKeyplan";
import React from "react";

const EditorDocumentContext = React.createContext<{
  isContentFromS3: boolean;
  isResetDataKeynote: boolean;
  isEditMode: boolean;
  isCreatingKeynote: boolean;
  callbackDragKeynoteStop: (keylabel: Partial<KeyLabel>) => void;
}>({} as any);

export default EditorDocumentContext;
